module.exports = __webpack_public_path__ + "img/faq.0a86ef53.svg";